"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

/**
 * Vrati query part pre vyhladavanie textu bez diakritiky so ciastocnou shodou vsetkych chunkov.
 *
 * Pokial `value` obsahuje medzery bude rozdelene na chunky. K zhode dojde v pripade, ze cielovy
 * text obsahuje vsetky z chunky. V cielovych textoch sa hlada ciastocna zhoda chunku.
 *
 * Napriklad:
 * 'aáaa' =$contains=> 'aaaa'
 * 'aáaa' =$contains=> 'aaaa ccc'
 * 'aáaa' =$contains=> 'bb aaaa ccc'
 * 'aáaa' =$contains=> 'bb aaaaaaaaa ccc'
 * 'aáaa bbb' =$contains=> 'bbb aaaaaaaaa ccc'
 * 'aáaa bbb' =$contains=> 'bbbbbb aaaaaaaaa ccc'
 * 'aáaa aaa' =$contains=> 'aaaa aaaa'
 * 'aáaaa bbb' =! $contains=> 'bb aa'
 *
 * Je vhodny pri vyhladavani v kontaktoch.
 *
 * @param {string} fieldName
 * @param {string} value
 *
 * @returns {Object}
 */
var textContainsToQuery = function textContainsToQuery(fieldName, value) {
  return value === undefined ? undefined : (0, _defineProperty2.default)({}, fieldName, {
    $contains: value
  });
};

var _default = textContainsToQuery;
exports.default = _default;